import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ErrorModalComponent } from './error-modal/error-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  constructor() {
    this.router.events.subscribe(() => {
      this.clear();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public errorsValue: Set<any> = new Set<any>();
  /**
   * Errors are stored in a subject so the modal showing the errors can be updated when the errors change
   */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private errors: BehaviorSubject<Set<any>> = new BehaviorSubject<Set<any>>(this.errorsValue);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors$: Observable<Set<any>> = this.errors.asObservable();

  // Used to prevent multiple modals from opening
  public isModalOpen = false;

  public isValidOrMakeError(form: FormGroup) {
    form.updateValueAndValidity();
    if (form.invalid) {
      this.makeErrorMessage(form);
      return false;
    }
    return true;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public makeErrorMessage(from_error: any) {
    console.error(from_error);
    let error = from_error || {};
    if (typeof from_error === 'string') {
      error = new Error(from_error);
    }

    if (from_error instanceof FormGroup) {
      error.message = 'Invalid Client Error';
      error._links = { _self: new Error().stack };
      error._embedded = { errors: [] };
      console.error('Invalid form', from_error);

      this.printFormValidationErrors(from_error);

      // Vérifiez l'état du formulaire
      console.log('Formulaire valide :', from_error.valid);

      // Vérifiez l'état de chaque contrôle
      Object.keys(from_error.controls).forEach((key) => {
        const control = from_error.get(key);
        console.log(`Contrôle ${key} valide :`, control?.valid);
        console.log(`Contrôle ${key} erreurs :`, control?.errors);
        console.log(`Contrôle ${key} état :`, control?.status);
      });

      for (const key in from_error.controls) {
        if (from_error.controls[key].invalid) {
          console.error(key, from_error.controls[key].errors);
          const errorMessage = from_error.controls[key].errors;
          if (errorMessage && typeof errorMessage['message'] === 'string') {
            error._embedded.errors.push({ message: errorMessage['message'] });
          } else {
            error._embedded.errors.push({
              message: key + ': ' + JSON.stringify(from_error.controls[key].errors, null, 2),
            });
          }
        }
      }
    }

    const errorAlreadyExists = Array.from(this.errorsValue).some(
      (existingError) => existingError.message === error.message,
    );

    if (!errorAlreadyExists) {
      console.error('Error:', error);
      this.errorsValue.add(error);
      this.errors.next(this.errorsValue);
      if (!this.isModalOpen) {
        this.isModalOpen = true;
        this.dialog.open(ErrorModalComponent, {
          width: '800px',
          data: error,
        });
      }
    }
  }

  printFormValidationErrors(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const controlErrors = formGroup.get(key)!.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          console.log(
            'Key control: ' + key + ', keyError: ' + keyError + ', err value: ',
            controlErrors[keyError],
          );
        });
      }
    });
  }

  public clear() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.errorsValue = new Set<any>();
    this.errors.next(this.errorsValue);
    this.isModalOpen = false;
  }
}
